"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWGameEventMapToJSON = exports.OWGameEventMapFromJSONTyped = exports.OWGameEventMapFromJSON = void 0;
function OWGameEventMapFromJSON(json) {
    return OWGameEventMapFromJSONTyped(json, false);
}
exports.OWGameEventMapFromJSON = OWGameEventMapFromJSON;
function OWGameEventMapFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'gameId': json['gameId'],
        'mappings': json['mappings'],
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}
exports.OWGameEventMapFromJSONTyped = OWGameEventMapFromJSONTyped;
function OWGameEventMapToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'gameId': value.gameId,
        'mappings': value.mappings,
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}
exports.OWGameEventMapToJSON = OWGameEventMapToJSON;
